import { CmsObjectWithDefault } from '@components/Cms/types';

export type PhoneLoginFormContainerCmsKey = 'pleaseEnterValidMobileNumber' | 'passwordValidation';

export const PhoneLoginFormContainerCmsWithDefault: CmsObjectWithDefault<PhoneLoginFormContainerCmsKey> = {
    pleaseEnterValidMobileNumber: {
        cmsId: 85560,
        defaultTranslation: 'Please enter a valid mobile number.',
    },
    passwordValidation: {
        cmsId: 76304,
        defaultTranslation: 'Please enter a valid password',
    },
};
